<template>
  <section id="section-footer" :style="backgroundStyle">
    <b-container>
      <div class="info-contact">
        <div class="primary-contact flex-col">
          <span class="header">General Inquiries</span>
          <span class="bold">Samir Rehem</span>
          <span class="regular">
            <a
              href="mailto:samir@samirrehem.com"
              target="_blank"
              class="underline"
            >samir@samirrehem.com</a>
          </span>
          <div class="info-links">
            <div class="link-icons">
              <a href="https://vimeo.com/sodasamson" target="_blank" class="underline">
                <div class="vimeo colorless-brand" />
              </a>
              <a href="https://www.imdb.com/name/nm0716813/" target="_blank" class="underline">
                <div class="imdb colorless-brand" />
              </a>
              <a href="https://www.linkedin.com/in/samirrehem" target="_blank" class="underline">
                <div class="linkedIn colorless-brand" />
              </a>
              <a href="https://twitter.com/sodasamson" target="_blank" class="underline">
                <div class="twitter colorless-brand" />
              </a>
            </div>
          </div>
        </div>
        <div class="flex-col">
          <span class="header">{{ $store.state.global.footer['column_1'][0]['column_name'] }}</span>

          <span class="bold">{{ $store.state.global.footer['column_1'][0]['organization'] }}</span>
          <span class="regular">{{ $store.state.global.footer['column_1'][0]['name'] }}</span>

          <span class="regular">
            <a
              :href="`mailto:${ $store.state.global.footer['column_1'][0]['email'] }`"
              target="_blank"
              class="underline"
            >{{ $store.state.global.footer['column_1'][0]['email'] }}</a>
          </span>
          <span class="regular">{{ $store.state.global.footer['column_1'][0]['number'] }}</span>
        </div>
        <div class="flex-col">
          <span class="header">{{ $store.state.global.footer['column_2'][0]['column_name'] }}</span>

          <span class="bold">{{ $store.state.global.footer['column_2'][0]['organization'] }}</span>
          <span class="regular">{{ $store.state.global.footer['column_2'][0]['name'] }}</span>

          <span class="regular">
            <a
              :href="`mailto:${ $store.state.global.footer['column_2'][0]['email'] }`"
              target="_blank"
              class="underline"
            >{{ $store.state.global.footer['column_2'][0]['email'] }}</a>
          </span>
          <span class="regular">{{ $store.state.global.footer['column_2'][0]['number'] }}</span>
        </div>
        <div class="flex-col">
          <span class="header">{{ $store.state.global.footer['column_3'][0]['column_name'] }}</span>

          <span class="bold">{{ $store.state.global.footer['column_3'][0]['organization'] }}</span>
          <span class="regular">{{ $store.state.global.footer['column_3'][0]['name'] }}</span>

          <span class="regular">
            <a
              :href="`mailto:${ $store.state.global.footer['column_3'][0]['email'] }`"
              target="_blank"
              class="underline"
            >{{ $store.state.global.footer['column_3'][0]['email'] }}</a>
          </span>
          <span class="regular">{{ $store.state.global.footer['column_3'][0]['number'] }}</span>
        </div>
      </div>
      <span class="designedby">
        Site by
        <a href="https://quitefrank.co" target="_blank" class="underline">Quite Frank</a>
      </span>
    </b-container>
  </section>
</template>

<script>

export default {
  name: "Footer",
  computed: {
    primaryBackgroundColor(){
      return `--new_white: ${this.$store.getters.themeSettings.primary_background_color};`;
    },
    backgroundStyle() {
      return `${this.primaryBackgroundColor}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  padding: 0;
}
#section-footer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: var(--new_white);
  color: #000;
  padding: 50px 0;
  max-width: 100vw;
  z-index: 99;
  position: relative;
  .container {
    @media (max-width: $sm) {
      margin: 0;
    }
  }
  .info-contact {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 81px;
    @media (max-width: $lg) {
      margin-bottom: 30px;
    }
    @media (max-width: $sm) {
      flex-direction: column;
    }
    .primary-contact {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin: 0 20px;
      @media (max-width: $lg) {
        width: 90%;
      }
    }
    @media (max-width: $lg) {
      display: flex;
    }

    .flex-col {
      @media (max-width: $lg) {
        width: 90%;
        margin-bottom: 50px;
      }
      margin: 0 20px;
    }
  }
  .designedby {
    font-family: "AvenirLTStd-Roman";
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 24px;
    justify-self: flex-end;
    align-self: flex-end;
    padding: 0 20px;
    @media (max-width: $lg) {
      align-self: flex-start;
    }
    a {
      text-decoration: none;
      color: #000;
    }
  }
  .info-links {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 5px;

    .link-icons {
      display: flex;
      flex-direction: row;
      a {
        transition: all 0.5s ease-in-out;
        opacity: 1;
        position: relative;

        .colorless-brand {
          background: $new_black;
          background-repeat: no-repeat;
          background-position: center center;
          transition: all 0.5s ease-in-out;
          height: 35px;
          width: 35px;
          margin-right: 1px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .imdb {
          background-image: url("~@/assets/images/icons/imdb.svg");
          &:hover {
            background-color: $brand_imdb;
          }
        }
        .imdb-brand {
          background-image: url("~@/assets/images/icons/imdb-brand.svg");
        }
        .vimeo {
          background-image: url("~@/assets/images/icons/vimeo.svg");
          &:hover {
            background-color: $brand_vimeo;
          }
        }
        .vimeo-brand {
          background-image: url("~@/assets/images/icons/vimeo-brand.svg");
        }
        .linkedIn {
          background-image: url("~@/assets/images/icons/linkedIn.svg");
          &:hover {
            background-color: $brand_linkedIn;
          }
        }
        .linkedIn-brand {
          background-image: url("~@/assets/images/icons/linkedIn-brand.svg");
        }
        .twitter {
          background-image: url("~@/assets/images/icons/twitter.svg");
          &:hover {
            background-color: $brand_twitter;
          }
        }
        .twitter-brand {
          background-image: url("~@/assets/images/icons/twitter-brand.svg");
        }
      }
    }
  }
  .regular {
    font-family: "AvenirLTStd-Roman";
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 24px;
    a {
      text-decoration: none;
      color: #000;
    }
  }
  .bold {
    font-family: "AvenirLTStd-Black";
    font-size: 18px;
    color: #000000;
    letter-spacing: 0;
    line-height: 24px;
    text-transform: uppercase;
  }
  .header {
    font-family: "AvenirLTStd-Roman";
    font-weight: 900;
    font-size: 12px;
    line-height: 24px;
    color: #000;
    text-transform: uppercase;
    padding-bottom: 10px;
  }
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
</style>

<style lang="scss">
.underline {
  display: inline;
  position: relative;
  overflow: hidden;
}
.underline:after {
  content: "";
  position: absolute;
  z-index: -1;
  left: 0;
  width: 0;
  bottom: -2px;
  background: #000;
  height: 1px;
  transition-property: width;
  transition-duration: 0.3s;
  transition-timing-function: ease-out;
  pointer-events: none;
}
.underline:hover:after,
.underline:focus:after,
.underline:active:after {
  // left: 0;
  // right: auto;
  width: 100%;
}
</style>